import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/tailwind/tailwind.css";
import "./assets/styles/main.scss";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import Loader from "@/components/notification/Loader.vue";
import SmallLoader from "@/components/notification/SmallLoader.vue";
import Tooltip from "@/components/general/Tooltip.vue";

import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import permissionDirective from "@/utils/directives/permissionDirective";

const app = createApp(App);

app
  .use(store)
  .use(router)
  .use(permissionDirective)
  .component("Datepicker", Datepicker)
  .component(Skeletor.name, Skeletor)
  .component("Loader", Loader)
  .component("SmallLoader", SmallLoader)
  .component("Tooltip", Tooltip)
  .mount("#app");

app.config.unwrapInjectedRef = true;
